import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/blog',
      name: 'blog',
      component: () => import('./views/Blog.vue')
    },
    {
      path: '/blog-detail/:postid/:description',
      name: 'blogdetail',
      component: () => import('./views/Blog-Detail.vue')
    },
    {
      path: '/my-skills',
      name: 'myskills',
      component: () => import('./views/My-Skills.vue')
    },
    {
      path: '/this-site',
      name: 'thissite',
      component: () => import('./views/This-Site.vue')
    },
    {
      path: '/jack-isa',
      name: 'jackisa',
      component: () => import('./views/Jack-Isa.vue')
    }
  ]
})
